"use client";
import Image from "next/image";
import Link from "next/link";
import { Typography } from "../typography/typography";
import {
  // footerLinks,
  footerSections,
  footerSocialLinks,
} from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="font-[family-name:var(--font-manrope)]">
      <div className="hidden sm:block">
        {/* <div className="bg-gray-blue-100">
          <div className="app-container mb-8 py-12">
            <Typography
              variant="p"
              as="p"
              className="mb-4 font-bold text-gray-900">
              Holiday bookings
            </Typography>
            <div className="hidden flex-wrap justify-between gap-x-8 gap-y-2 lg:flex">
              {Array.from({ length: 7 }, (_, colIndex) => (
                <div key={colIndex} className="flex flex-col gap-3">
                  {footerLinks.map((link) => (
                    <Link
                      key={link.label}
                      href={link.url}
                      className="text-md block font-[500] text-gray-700 hover:text-gray-800">
                      {link.label}
                    </Link>
                  ))}
                </div>
              ))}
            </div>

            <div className="grid grid-cols-4 gap-x-6 gap-y-2 lg:hidden">
              {Array.from({ length: 4 }, (_, colIndex) => (
                <div key={colIndex} className="flex flex-col gap-3">
                  {footerLinks.map((link) => (
                    <Link
                      key={link.label}
                      href={link.url}
                      className="text-md block font-[500] text-gray-700 hover:text-gray-800">
                      {link.label}
                    </Link>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div> */}

        <div className="bg-gray-blue-100">
          <div className="app-container flex h-full w-full flex-wrap gap-x-64 py-7.5">
            <div className="">
              <div className="mb-4 flex items-center">
                <Image
                  src="/icons/logo.svg"
                  alt="Lykke Travel"
                  width={137}
                  height={48}
                  className="mr-2"
                />
              </div>
              <Typography
                variant="h2"
                as="h2"
                className="text-display-xs md:text-display-md font-family-body mb-2 font-semibold text-gray-700">
                Holidays For <br />
                Global Indians
              </Typography>
            </div>

            <div className="flex flex-1 flex-wrap justify-around gap-8">
              {footerSections.map((section) => (
                <div key={section.title} className="flex flex-col gap-2">
                  <Typography
                    variant="h4"
                    as="h4"
                    className="font-family-body text-md mb-4 font-bold text-gray-800">
                    {section.title}
                  </Typography>
                  <div className="flex flex-col gap-3">
                    {section.links.map((link) => (
                      <Link
                        key={link.label}
                        href={link.url}
                        className="text-md block font-normal text-gray-600 hover:text-gray-800">
                        {link.label}
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-blue-100 overflow-x-hidden pt-4 pb-4 sm:hidden">
        {/* <div className="bg-gray-blue-100 mb-8">
          <div className="app-container py-6">
            <button
              className="flex w-full items-center justify-between text-left"
              onClick={() => {
                const content = document.getElementById(
                  "mobile-holiday-bookings"
                );
                const icon = document.getElementById("holiday-bookings-icon");
                if (content && icon) {
                  content.classList.toggle("hidden");
                  icon.style.transform = content.classList.contains("hidden")
                    ? "rotate(0deg)"
                    : "rotate(180deg)";
                }
              }}>
              <Typography variant="h3" as="h3" className="text-gray-800">
                Holiday bookings
              </Typography>
              <svg
                id="holiday-bookings-icon"
                className="h-5 w-5 transform transition-transform duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <div id="mobile-holiday-bookings" className="mt-4 hidden">
              <div className="grid grid-cols-2 gap-4">
                {Array.from({ length: 2 }, (_, colIndex) => (
                  <div key={colIndex} className="flex flex-col gap-3">
                    {footerLinks.map((link) => (
                      <Link
                        key={link.label}
                        href={link.url}
                        className="text-md block font-[500] text-gray-700 hover:text-gray-800">
                        {link.label}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div> */}

        <div className="app-container px-4">
          <div className="mb-4 flex items-center">
            <Image
              src="/icons/logo.svg"
              alt="Lykke Travel"
              width={114}
              height={40}
              className="mr-2"
            />
          </div>
          <Typography
            variant="h3"
            as="h3"
            className="text-display-xs font-family-body mb-8 font-extrabold text-gray-600">
            Holidays for Global Indians
          </Typography>
        </div>

        <div className="mx-8 mb-8 grid grid-cols-2 gap-6">
          {footerSections.map((section) => (
            <div key={section.title} className="flex flex-col gap-3">
              <Typography
                variant="h4"
                as="h4"
                className="font-family-body text-md mb-4 font-bold text-gray-800">
                {section.title}
              </Typography>
              <div className="flex flex-col space-y-2">
                {section.links.map((link) => (
                  <Link
                    key={link.label}
                    href={link.url}
                    className="text-md block min-w-0 font-normal break-words whitespace-normal text-gray-600 hover:text-gray-800">
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-blue-100 pb-6">
        <div className="app-container border-t border-gray-300 pt-6">
          <div className="flex flex-col-reverse items-center justify-between gap-8 md:flex-row">
            <div className="text-center text-sm font-normal text-gray-600 md:text-left">
              © {new Date().getFullYear()} TRAVEL LYKKE PRIVATE LIMITED. <br className="md:hidden" />
              All Rights Reserved
            </div>
            <div className="flex space-x-4">
              {footerSocialLinks.map((icon) => (
                <Link
                  key={icon.title}
                  href={icon.href}
                  target="_blank"
                  className="bg-gray-blue-100 flex h-8 w-8 items-center justify-center rounded-full transition-colors">
                  <Image
                    src={icon.icon}
                    alt={icon.title}
                    width={16}
                    height={16}
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
